module.exports = __webpack_public_path__ + "static/media/sigla1.adca80e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/sigla1.png
// module id = 488
// module chunks = 0